import { ELanguage } from '@app/app.interface';

export const LOCALE_MAP: Record<ELanguage, string> = {
  [ELanguage.en]: 'en-GB',
  [ELanguage.de]: 'de-DE',
};
